module.exports = __webpack_public_path__ + "img/login.3adc0fa9.png";